export default __webpack_public_path__ + "images/W2.53e136d.png";